<script setup>
import AbstractGroup from "./AbstractGroup.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import { getLocale } from "../../../translations";
import Icon from "../../Common/Icon.vue";
import { formatDate } from "../../../helpers/date";
import { isDarkmode } from "../../../helpers/darkmode";
import { computed, ref } from "vue";

const dateFrom = defineModel("dateFrom");
const dateTo = defineModel("dateTo");

const pickerFrom = ref(null);
const pickerTo = ref(null);

const isGroupActive = computed(() => {
  return !!(dateFrom.value || dateTo.value);
});

function displayDate(date) {
  if (!date) {
    return "-";
  }

  return formatDate(date, "Do MM. YYYY");
}

function reset(date) {
  if (date === "from") {
    dateFrom.value = null;
  }

  if (date === "to") {
    dateTo.value = null;
  }
}

function displayReset(date) {
  return date !== null;
}
</script>

<template>
  <AbstractGroup class="group">
    <template #header>
      <span
        class="block transition group-hover:translate-x-2"
        :class="isGroupActive ? 'text-primary' : ''"
        v-t="'filter.group.date'"
      ></span>
    </template>
    <template #inner>
      <div class="px-10 lg:px-16 py-6 text-16 lg:text-20 flex items-center gap-x-4 border-b border-dark/10">
        <p class="shrink-0 text-dark/50" v-t="'filter.group.date.label.from'" @click="pickerFrom.openMenu()"></p>

        <p class="grow" v-text="displayDate(dateFrom)" @click="pickerFrom.openMenu()"></p>

        <button v-if="displayReset(dateFrom)" class="transition-opacity" @click="reset('from')" type="button">
          <Icon name="close" class="shrink-0 size-4" />
        </button>

        <VueDatePicker
          :locale="getLocale()"
          v-model="dateFrom"
          :teleport="true"
          ref="pickerFrom"
          format="dd. MM. yyyy"
          class="!w-fit cursor-pointer"
          :enable-time-picker="false"
          :dark="isDarkmode()"
          model-type="iso"
          :auto-apply="true"
        >
          <template #trigger>
            <Icon name="calender" class="size-4 shrink-0 text-primary" />
          </template>
        </VueDatePicker>
      </div>

      <div class="px-10 lg:px-16 py-6 text-16 lg:text-20 flex items-center gap-x-4">
        <p class="shrink-0 text-dark/50" v-t="'filter.group.date.label.to'" @click="pickerTo.openMenu()"></p>

        <p class="grow" v-text="displayDate(dateTo)" @click="pickerTo.openMenu()"></p>

        <button v-if="displayReset(dateTo)" class="transition-opacity" @click="reset('to')" type="button">
          <Icon name="close" class="shrink-0 size-4" />
        </button>

        <VueDatePicker
          :locale="getLocale()"
          v-model="dateTo"
          :teleport="true"
          ref="pickerTo"
          format="dd. MM. yyyy"
          class="!w-fit cursor-pointer"
          :enable-time-picker="false"
          :dark="isDarkmode()"
          model-type="iso"
          :auto-apply="true"
        >
          <template #trigger>
            <Icon name="calender" class="size-4 shrink-0 text-primary" />
          </template>
        </VueDatePicker>
      </div>
    </template>
  </AbstractGroup>
</template>
